export enum CoreLocationApiTags {
  City = 'City',
  CityList = 'CityList',
  MainLinkingCitiesList = 'MainLinkingCitiesList',
}
export const coreLocationApiTagTypes = Object.values(CoreLocationApiTags);
